import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import GenericButton from 'src/components/GenericButton';
import ModalLayoutBase, { MobileModalType, ModalFooter as ModalFooterBase, ModalHeader, ModalTitle as ModalTitleBase, ModalTitleDescription } from 'src/components/ModalLayout';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { ModalNavButtonType, ModalType } from 'src/types/Modal';
const ModalLayout = styled(ModalLayoutBase)`
  background-color: ${({
  theme
}) => theme.color.bg2};

  ${({
  theme
}) => theme.screenSize.desktop} {
    max-width: 400px;
  }
`;
const ModalTitle = styled(ModalTitleBase)`
  font-size: 22px;
  font-weight: 900;
`;
const ModalFooter = styled(ModalFooterBase)`
  gap: 12px;
`;
const ItemLackModal = () => {
  const {
    t
  } = useTranslation();
  const closeModal = useSetAtom(closeModalAtom);
  const handleClose = () => {
    closeModal(ModalType.MATCH_TIMEOUT);
  };
  return <ModalLayout isDim mobileType={MobileModalType.BOTTOM_SHEET} navButtonType={ModalNavButtonType.NONE} mobileNavButtonType={ModalNavButtonType.NONE} onClose={handleClose} data-sentry-element="ModalLayout" data-sentry-component="ItemLackModal" data-sentry-source-file="index.tsx">
      <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">
        <ModalTitle data-sentry-element="ModalTitle" data-sentry-source-file="index.tsx">{t('vividi_finding_no_match_popup_title')}</ModalTitle>
        <ModalTitleDescription data-sentry-element="ModalTitleDescription" data-sentry-source-file="index.tsx">{t('vividi_finding_no_match_popup_msg')}</ModalTitleDescription>
      </ModalHeader>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="index.tsx">
        <GenericButton type='button' size='large' variant='primary' onClick={handleClose} data-sentry-element="GenericButton" data-sentry-source-file="index.tsx">
          {t('vividi_finding_no_match_popup_button')}
        </GenericButton>
      </ModalFooter>
    </ModalLayout>;
};
export default ItemLackModal;